<div class="card-body">
    <div [formGroup]="form" class="row">
        <div class="col-md-4" *ngFor="let item of dataSource">
            <h4>{{ item.setting.name }}:</h4>
            <mat-select [formControlName]="item.setting.key" name="item.setting.key" class="dropdown-wrapper" panelClass="dropdown-wrapper">
                <mat-option class="option-list" *ngFor="let opt of item.setting.settingValues" [value]="opt.settingValueId">{{ opt.value }}</mat-option>
            </mat-select>
        </div>
    </div>
</div>
